// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1suKE","buttons":"Footer_buttons__16-ht"};